
export default {
	state: {
		unitsTypes: [],
		unitsHwTypesSettings: {},
	},
	actions: {
		fetchUnitsTypes({dispatch, commit, getters}) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken) {
					return reject(false)
				}
				dispatch('setLastCall', {name: 'fetchUnitsTypes', time: Date.now() / 1000})

				this.$api.unitshelper.getTypes()
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							commit('updateUnitsTypes', response.data)
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						dispatch('setLastCall', {name: 'fetchUnitsTypes', inprogress: false})
					});
			})
		},
		fetchUnitsHwTypesSettings({dispatch, commit, getters}) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken) {
					return reject(false)
				}
				dispatch('setLastCall', {name: 'fetchUnitsHwTypesSettings', time: Date.now() / 1000})

				this.$api.unitshelper.getHwTypesSettings()
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							commit('updateUnitsHwTypesSettings', response.data)
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						dispatch('setLastCall', {name: 'fetchUnitsHwTypesSettings', inprogress: false})
					});
			})
		},

		fetchUnitTypesByHwType({getters}, args) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken && !args?.hw_type) {
					return reject(false)
				}
				//dispatch('setLastCall', {name: 'fetchUnitTypesByHwType', args, time: Date.now() / 1000})
				this.$api.unitshwtypes.getTypes(args.hw_type, {})
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						//dispatch('setLastCall', {name: 'fetchUnitTypesByHwType', args, inprogress: false})
					});
			})
		},
		fetchUnitAttrsByHwType({getters}, args) {
			return new Promise((resolve, reject) => {
				if (!getters.getApiToken && !args?.hw_type) {
					return reject(false)
				}
				//dispatch('setLastCall', {name: 'fetchUnitTypesByHwType', args, time: Date.now() / 1000})
				this.$api.unitshwtypes.getAttrs(args.hw_type, {})
					.then((response) => {
						if (response.status < 400 && !response.data?.error) {
							resolve(response.data)
						} else {
							reject(response)
						}
					})
					.catch((error) => {
						reject(error)
						console.error(error);
					})
					.finally(() => {
						//dispatch('setLastCall', {name: 'fetchUnitTypesByHwType', args, inprogress: false})
					});
			})
		},

	},
	mutations: {
		updateUnitsTypes(state, unitsTypes) {
			state.unitsTypes = unitsTypes
		},
		updateUnitsHwTypesSettings(state, unitsHwTypesSettings) {
			state.unitsHwTypesSettings = unitsHwTypesSettings
		},
	},
	getters: {
		getUnitsTypes(state) {
			return state.unitsTypes
		},
		getUnitsTypesByType(state) {
			return state.unitsTypes.reduce((out, type) => {
				out[type.id] = type
				return out;
			}, {})
		},
		getUnitsHwTypesSettings(state) {
			return state.unitsHwTypesSettings
		},
	},
}